import { WidgetsSettingsMain } from '@/widgets/settings';

export const PagesSettingsMain = () => <WidgetsSettingsMain />;
